<div class="horus-loader">
  <svg class="spin" xmlns="http://www.w3.org/2000/svg" width="29" height="30" viewBox="0 0 29 30" fill="none">
    <path d="M23.5 29.5L28.5 4L19 15L23.5 29.5Z" fill="url(#paint0_linear_35_4680)"/>
    <path d="M13.5 15.5L0 13.5L19 30L13.5 15.5Z" fill="url(#paint1_linear_35_4680)"/>
    <path d="M14 11L0 9L23.5 0L14 11Z" fill="url(#paint2_linear_35_4680)"/>
    <defs>
      <linearGradient id="paint0_linear_35_4680" x1="19" y1="29.5" x2="31.3345" y2="28.0461" gradientUnits="userSpaceOnUse">
        <stop stop-color="#1DA1F2"/>
        <stop offset="1" stop-color="#2178EA"/>
      </linearGradient>
      <linearGradient id="paint1_linear_35_4680" x1="0" y1="30" x2="22.0806" y2="21.955" gradientUnits="userSpaceOnUse">
        <stop stop-color="#1DA1F2"/>
        <stop offset="1" stop-color="#2178EA"/>
      </linearGradient>
      <linearGradient id="paint2_linear_35_4680" x1="0" y1="11" x2="21.2335" y2="-3.35299" gradientUnits="userSpaceOnUse">
        <stop stop-color="#1DA1F2"/>
        <stop offset="1" stop-color="#2178EA"/>
      </linearGradient>
    </defs>
  </svg>
</div>